import { Actions } from '../actions/verificationActions';
import { VerificationActionTypes } from '../models/actions/verification';

export interface IVerificationState {
  verificationLink: string;
}

const initialState: IVerificationState = {
  verificationLink: '',
};

export default function verificationReducer(state = initialState, action: Actions): IVerificationState {
  switch (action.type) {
    case VerificationActionTypes.verify:
      return { ...state, ...action };
    default:
      return state;
  }
}
